export const MAX_BREAK_HOURS = 8;
export const MAX_DEDUCTION = 500;
